import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MazotFiyatlarPage } from 'src/model/mazot-fiyatlar-page';
import { Page } from 'src/model/page';
import { HelperProvider } from 'src/providers/helper.provider';
import { RestService } from 'src/providers/rest.service';

@Component({
  selector: 'app-lojistik-fiyat-arsivler',
  templateUrl: './lojistik-fiyat-arsivler.component.html',
  styleUrls: ['./lojistik-fiyat-arsivler.component.css']
})
export class LojistikFiyatArsivlerComponent implements OnInit {

  showSearchResultCount = 10;
  showSearchResultCountModel: number[] = [10, 20, 50, 100];
  talepAraLoading = false;
  talepAraText = '';
  source: MazotFiyatlarPage = null;
  showSearchCurrentPage = 1;
  private subscriptions: Subscription[] = [];

  constructor(private helperProvider: HelperProvider, private restService: RestService
    , private router: Router) { }

  ngOnInit() {
    this.helperProvider.currentPage$.next(Page.Lojistikler);
    this.getLojistikFiyatlar();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getLojistikFiyatlar() {
    // const durum = this.filterStatus.filter(x => x.value).map(x => x.key);
    this.restService.getLojistikFiyatlar(this.showSearchCurrentPage, this.showSearchResultCount, null, "").subscribe(res => {
      this.source = res;
      console.log(res);
    });
  }

  showPreviousPageSearchResults() {
    this.showSearchCurrentPage--;
    this.getLojistikFiyatlar();
  }

  showNextPageSearchResults() {
    this.showSearchCurrentPage++;
    this.getLojistikFiyatlar();
  }

  fiyatAraInputChange() {
    this.showSearchCurrentPage = 1;
    this.getLojistikFiyatlar();
  }

  new() {
    this.router.navigate(['lojistik-fiyat-arsiv-olustur'], { queryParams: { id: '0' } });
  }
}
